export default __webpack_public_path__ + "static/1-e7baa46048cc0abec73d05ccabd1d7de.png";